import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {

   public yearFull;

    ngOnInit() {
       /* Back To Top */
   let dt = new Date();

        this.yearFull = dt.getFullYear()
        $(document).ready(() => {
            $(window).on('scroll', () => {
                if ($(this).scrollTop() > 300) {
                    $('.back-to-top').fadeIn();
                } else {
                    $('.back-to-top').fadeOut();
                }
            });

            $('.back-to-top').on('click', () => {
                $('html, body').animate({ scrollTop: 0 }, 600);
                return false;
            });
        });
    }
}
